import * as React from "react";
import type { SVGProps } from "react";
const PillIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M15 6.5H9a5.5 5.5 0 1 0 0 11h6a5.5 5.5 0 1 0 0-11M9 5a7 7 0 0 0 0 14h6a7 7 0 1 0 0-14z" clipRule="evenodd" /></svg>;
export default PillIcon;